import { render, staticRenderFns } from "./Dossier.vue?vue&type=template&id=12c75b3e&scoped=true"
import script from "./Dossier.vue?vue&type=script&lang=js"
export * from "./Dossier.vue?vue&type=script&lang=js"
import style0 from "./Dossier.vue?vue&type=style&index=0&id=12c75b3e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c75b3e",
  null
  
)

export default component.exports